import Carousel from './Components/productGallery';
import CustomPrice from './Components/customPrice';
import CustomQuanityChange from './Components/quanityChange';
import CustomVariation from './Components/customVariation';

document.addEventListener('DOMContentLoaded', () => {
    initSlider();
    initCustomPrice();
    initQuanityChange();
    initVariationRadiosButtons();
});

const initSlider = async () => {
    try {
        const container = await isSliderExist();

        const carousel = new Carousel(container);

        await listenerForVariationChange(carousel);
    } catch (error) {}
};

const initCustomPrice = async () => {
    new CustomPrice().init();
};

const isSliderExist = () => {
    return new Promise((resolve, reject) => {
        const sliderContainer = document.querySelector('.thumbnail-carousel');

        sliderContainer !== undefined && sliderContainer !== null ? resolve(sliderContainer) : reject();
    });
};

const initQuanityChange = async () => {
    const button = document.querySelector('.quantity');

    if (button) new CustomQuanityChange(button);
};

const initVariationRadiosButtons = async () => {
    try {
        const wrappers = await productHasVariations();
        new CustomVariation(wrappers);
    } catch (error) {}
};

const productHasVariations = () => {
    return new Promise((resolve, reject) => {
        const radiosWrapper = [...document.querySelectorAll('.variation-custom-radio-wrapper')];

        if (radiosWrapper.length < 1) reject();

        resolve(radiosWrapper);
    });
};

const listenerForVariationChange = (carousel) => {
    return new Promise((resolve, reject) => {
        const variationsContainer = document.querySelector('.product-gallery--variations');
        if (variationsContainer === null || variationsContainer === undefined) reject();

        jQuery('input.variation_id').change(function () {
            if ('' != jQuery(this).val()) {
                const id = jQuery(this).val();
                carousel.changeSlide(id);
            }
        });
    });
};
